export const fetchJson = async (url, options) => {
  return fetch(url, options).then((response) => {
    if (!response.ok) {
      throw new Error(`Fetch data failed with status ${response.status}`);
    }
    return response.json();
  });
};
